import { render, staticRenderFns } from "./RestorePassword.vue?vue&type=template&id=3f504ec2&scoped=true&lang=pug&"
import script from "./RestorePassword.vue?vue&type=script&lang=js&"
export * from "./RestorePassword.vue?vue&type=script&lang=js&"
import style0 from "./RestorePassword.vue?vue&type=style&index=0&id=3f504ec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f504ec2",
  null
  
)

component.options.__file = "RestorePassword.vue"
export default component.exports